<template>
  <div>
    <div class="row" @mousemove="RemoveAlert()">
      <div class="col-md-6 col-xl-3" v-for="(stats, index) in getStats" :key="stats.title">
        <router-link :to="{ path: stats.url }">
          <stats-card>
            <div class="icon-big text-center" :class="`icon-${stats.type}`" slot="header">
              <i :class="stats.icon"></i>
            </div>
            <div class="numbers" slot="content">
              <p>{{ stats.title }}</p>
              {{ stats.value }}
            </div>
            <div class="stats" slot="footer">
              <i :class="stats.footerIcon"></i> {{ stats.footerText }}
            </div>
          </stats-card>
        </router-link>
      </div>
    </div>
<!-- 
      <card class="card" title=""><br />
        <div class="row">
          <div class="col-md-4">
            <div class="input-group mb-3">
              <div class="input-group-append" style="padding-left: 25px;">
                <h5>Estaciones </h5>
              </div>
            </div>
          </div>
          <div class="col-md-4"></div>
          <div class="col-md-4" :style="{ paddingRight: '33px' }" title="Agregar">
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="Buscar por nombre o número ..." v-model="word" />
              <div class="input-group-append">
                <button class="btn btn-info" type="info" @click="() => { page = 1; getStations() }">
                  <i class="material-icons white-text">search</i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <div class="col-md-12">
            <table class="table table-striped">
              <thead class="table-dark">
                <tr>
                  <th v-for="col in headers" :key="col.label">{{ col.label }}</th>
                </tr>
              </thead>
              <tbody v-if="content.length > 0">
                <tr v-for="(st) in content" :key="st.id">
                  <td>{{ st.station }}</td>
                  <td>{{ st.name }}</td>
                  <td>{{ st.commercial_name }}</td>
                  <td>{{ st.status === 1 ? 'Activa' : 'Inactiva' }}</td>
                  <td>{{ st.status === 1 ? '-' : formatDate(st.expiration_date) }}</td>
                  <td>
                    <i class="material-icons white-text" :style="{ cursor: 'pointer', color: 'red' }"
                      @click="() => deleteItem(st.id, st.station)" title="Eliminar">
                      delete
                    </i>
                    <i class="material-icons white-text" :style="{ cursor: 'pointer', color: '#17a2b8' }"
                      @click="() => modifyItem(st.id)" title="Modificar">
                      edit
                    </i>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" style="background-color:#eee;">
                    <center> Información no encontrada </center>
                  </td>
                </tr>
              </tbody>

            </table>
            <div v-if="content.length > 0">
              <p class="text-right" :style="{ paddingRight: '11px' }" v-if="count > (page * 5)">
                {{ ((page - 1) * 5) + 1 }} - {{ page * 5 }} de {{ count }} registros
              </p>
              <p class="text-right" :style="{ paddingRight: '11px' }" v-else>
                {{ ((page - 1) * 5) + 1 }} - {{ count }} de {{ count }} registros
              </p><br />
            </div>
            <div v-else> </div>
          </div><br />

          <div class="d-flex justify-content-center">
            <b-pagination v-model="page" :total-rows="count" prev-text="Anterior" next-text="Siguiente" :per-page="5"
              @change="handlePageChange" />
          </div>
        </div>
      </card>
    </div> --> 

    <div v-if="totalGB">
      <div class="row">
        <div class="col-md-6 col-12">
          <DataTable style="overflow-x: auto" title="Archivos respaldados" :columns="tableColumnsSmart"
            :rows="dataSmart" :printable="false" :paginate="false" :searchable="false" />
        </div>

        <div class="col-md-6 col-12">
          <DataTable style="overflow-x: auto" title="Espacio utilizado" :columns="tableColumnsSpace" :rows="dataSpace"
            :printable="false" :paginate="false" :searchable="false" />
        </div>
      </div>

      <!--  -->
      <div class="row">
        <div class="col-md-6">
          <h5>Archivos respaldados</h5>
          <div class="alert alert-info alert-with-icon" data-notify="container">
            <center>
              <span data-notify="icon" class="ti-files icon"></span>
              {{ dataSmart[0] ? dataSmart[0].total : '0' }}
            </center>
          </div>
        </div>
        <div class="col-md-6">
          <h5>Espacio utilizado</h5>
          <div class="alert alert-warning alert-with-icon" data-notify="container">
            <center>
              <span data-notify="icon" class="ti-harddrives"></span>
              <span data-notify="message">{{ totalGB }} GB</span>
            </center>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="alert alert-info" role="alert">
        Cargando datos, puede continuar con su navegación y regresar después :)
      </div>
    </div>
  </div>
</template>
<script>
import backedFilesService from "../services/backedFilesService";
import stationsService from "../services/stationsService";
import DataTable from "vue-materialize-datatable";
import { StatsCard } from "@/components/index";
import { PaperTable } from "@/components";
import state from "../store/state";
import auth from "../token";
let mouseStop = null
let time = 600000

export default {
  components: {
    StatsCard,
    PaperTable,
    DataTable,
  },
  created() {
    this.statsCards = state.menu;
    this.getStations()
    this.headers = state.stations.headersDash;
  },
  methods: {
    RemoveAlert() {
      clearTimeout(mouseStop)
      this.init()
    },
    init() {
      clearTimeout(mouseStop)
      mouseStop = setTimeout(this.closing, time)
    },
    closing() {
      alert('Cierre de sesion por inactividad, hasta pronto')
      auth.logout();
    },
    getRequestParams(page, word) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (word) {
        params["word"] = word;
      }

      return params;
    },
    async getStations() {
      const params = this.getRequestParams(
        this.page,
        this.word
      );
      const stations = await stationsService.getStations(params.page, params.word);
      const { content } = await stations.data.data;
      const { totalElements } = await stations.data.data;
      this.count = totalElements;
      this.content = content;
    },
    handlePageChange(value) {
      this.page = value;
      this.getStations();
    },
    refreshList() {
      this.getStations();
      this.currentStation = null;
      this.currentIndex = -1;
    },
    setActiveStation(station, index) {
      this.currentStation = station;
      this.currentIndex = index;
    },
    deleteItem(id, st) {
      swal({
        title: '¡Aviso!',
        text: '¿Eliminar estación ' + st + '?',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          stationsService.delete(id).then(response => {
            if (response.data.error === false) {
              swal({
                title: 'Exitoso',
                text: 'Se elimino la estación correctamente',
                icon: 'success',
                timer: 3000,
                buttons: false
              })
              setTimeout(() => {
                window.location.reload()
              }, 3000)
            } else {
              swal({
                title: '¡Algo salio mal!',
                text: 'Consulte con el administrador',
                icon: 'warning',
                timer: 3000,
                buttons: false
              })
            }
          })
        }
      })
    },
    modifyItem(id) {
      this.$router.push("/editar-estacion/" + id);
    },
    formatDate(date) {
      const d = date.toString().split('T')
      return d[0]
    }
  },
  async mounted() {
    this.init()
    let space = [];
    let bcks = [];
    let total = 0;
    this.dataSpace = [];
    this.dataSmart = [];
    try {
      space = JSON.parse(auth.getSpaceTable());
      bcks = JSON.parse(auth.getBackupsTable());
      total = auth.getTotalGB();
    } catch (error) { }
    if (space.length > 0 && bcks.length > 0) {
      this.dataSpace.push(...space);
      this.dataSmart.push(...bcks);
      this.totalGB = total;
    } else {

      const respS = await backedFilesService.list(0, 5);
      if (respS.data.data.content.length > 0) {
        respS.data.data.content.forEach((element) => {
          this.dataSpace.push({
            archivo: element.file_name,
            fecha: element.uploaded_date
          });
        });
      } else {
        this.dataSpace.push({
          archivo: 'no data',
          fecha: 'no data'
        });
      }

      const respH = await backedFilesService.getHomeData();
      if (respH.data.data.gbCount) {
        this.totalGB = respH.data.data.gbCount;
        this.dataSmart = [
          {
            smartbackups: "Total Archivos Respaldados",
            total: respH.data.data.countFile,
          },
          {
            smartbackups: "Archivos Tipo Control Volumétrico",
            total: respH.data.data.type3,
          },
          {
            smartbackups: "Archivos Tipo Factura",
            total: respH.data.data.type2,
          },
          {
            smartbackups: "Archivos Tipo Póliza",
            total: respH.data.data.type4,
          },
          {
            smartbackups: "Archivos Tipo Otros",
            total: respH.data.data.type1,
          },
        ];
      }

      if (this.dataSpace.length > 0) auth.setSpaceTable(this.dataSpace);
      if (this.dataSmart.length > 0) auth.setBackupsTable(this.dataSmart);
      if (this.totalGB) {
        auth.setTotalGB(this.totalGB);
      }
    }

    if (!localStorage.getItem('stationName')) {
      const resp = await stationsService.getStationByNumber(localStorage.getItem('station'))
      if (resp.data && resp.data.data) {
        const { id, name } = resp.data.data
        localStorage.setItem('stationName', name)
        localStorage.setItem('stationId', id)
      }
    }
  },
  computed: {
    getRol() {
      let att = JSON.parse(localStorage.getItem('attributes'));
      let roles = [];
      for (let key in att) {
        if (att.hasOwnProperty(key)) {
          if (att[key][0] === 'false') roles.push({ id: key, value: true })
        }
      }
      return roles;
    },
    getStats() {
      const stats = [];
      for (let i = 0; i < this.statsCards.length; i++) {
        for (let j = 0; j < this.getRol.length; j++) {
          if (this.statsCards[i].rol === this.getRol[j].id) {
            stats.push(this.statsCards[i])
          }
        }
      }
      return stats;
    }
  },
  data() {
    return {
      totalGB: 0,
      tableColumnsSmart: [
        {
          label: "Smart Backups",
          field: "smartbackups",
        },
        {
          label: "Total",
          field: "total",
        },
      ],
      dataSmart: [],
      tableColumnsSpace: [
        {
          label: "Últimos archivos respaldados",
          field: "archivo",
        },
        {
          label: "Fecha",
          field: "fecha",
        },
      ],
      dataSpace: [],
      statsCards: [],
      headers: [],
      content: [],
      currentStation: null,
      currentIndex: -1,
      word: "",

      page: 1,
      count: 0
    };
  },
};
</script>
<style>
.icon {
  width: 50%;
  margin: 0 auto;
}
</style>
